module.exports = __webpack_public_path__ + "img/BP-Logo 2.df6cd545.svg";